import * as yup from 'yup';

const LoginSchema = yup.object().shape({
    password: yup.string()
        .required('Required'),
    email: yup.string()
        .email('Please Enter a valid email')
        .required('Required'),
});

export default LoginSchema;